

































import Vue from 'vue';
import {
  OpenUpdateReleaseAuthorizationScreen,
  OpenRemoveReleaseAuthorizationScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';
import { MemberARIsResponseModel } from '@/@types/member';

export default ExtendMixins(
  OpenUpdateReleaseAuthorizationScreen,
  OpenRemoveReleaseAuthorizationScreen,
).extend({
  name: 'ReleaseAuthorizationListing',
  computed: {
    ariDesignees(): MemberARIsResponseModel[] {
      return this.$store.getters.ariDesignees;
    },
  },
});
